(function($, undefined) {
	'use strict';

	var initSlider = function() {
		$('.com-events').each(function() {
			var component = $(this);
			var slider = component.find('.all-events');
			
			slider.on('init', function(event, slick) {
				component.find('.events-genlist-item').removeClass('hidden');
			});

			slider.slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				prevArrow: component.find('.arrow-btn.prev'),
				nextArrow: component.find('.arrow-btn.next'),
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		});
	};

	var init = function() {
		if ($('.events-genlist-item').length > 0) {
			initSlider();
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
